import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../environments/environment';
import {ResponseApi} from './shared/models/data/response';

@Injectable({
  providedIn: 'root'
})
export class McTelephoneService {
    baseUrl: string;

    constructor(private http: HttpClient) {
        this.baseUrl = environment.serverURL;
    }

    getPhones(): Observable<ResponseApi<any> | HttpErrorResponse> {
        return this.http.get<any>(`${this.baseUrl}/mc-telephone/get-phones`);
    }

    addPhone(payload: any): Observable<ResponseApi<any> | HttpErrorResponse> {
        return this.http.post<any>(`${this.baseUrl}/mc-telephone/add-phone`, payload);
    }

    updatePhone(payload: any): Observable<ResponseApi<any> | HttpErrorResponse> {
        return this.http.put<any>(`${this.baseUrl}/mc-telephone/update-phone`, payload);
    }

    deletePhone(payload: any): Observable<ResponseApi<any> | HttpErrorResponse> {
        return this.http.post<any>(`${this.baseUrl}/mc-telephone/delete-phone`, payload);
    }

    detectCountryCode(phone: string): Observable<any> {
        return this.http.get<any>(`${this.baseUrl}/users/get-country-code`, {
            params: { phone }
        });
    }
}
